const ded = `<h1>Política de Privacidad</h1>
<h2>DressDown.me</h2>
<p><strong>Fecha de entrada en vigor:</strong> 01.05.2025</p>

<h2>Disposiciones Generales</h2>
<p>Esta Política de Privacidad (“Política”) regula la recopilación, almacenamiento, uso y transferencia de datos personales de los usuarios del sitio web <a href="https://dressdown.me">https://dressdown.me</a> (“Sitio”), de acuerdo con el Reglamento General de Protección de Datos (RGPD), la Directiva ePrivacy y otra legislación aplicable de la Unión Europea. Respetamos su derecho a la privacidad y nos comprometemos a tratar sus datos personales de forma responsable, segura y legal.</p>

<h2>Responsable del Tratamiento</h2>
<p>El responsable del tratamiento es:<br>
Prowenta Trade s.r.o<br>
Correo electrónico: <a href="mailto:support@dressdown.me">support@dressdown.me</a><br>
Dirección legal: Vikova 532/8, Zizkov (Praha 3), Praga, República Checa</p>

<h2>Datos que Procesamos</h2>
<p>Podemos recopilar y tratar las siguientes categorías de datos personales:</p>
<ul>
  <li>Datos de contacto: correo electrónico</li>
  <li>Datos de cuenta: usuario, contraseña cifrada, configuración del perfil</li>
  <li>Datos de pago: tratados por un proveedor externo</li>
  <li>Datos técnicos: dirección IP, geolocalización, tipo de dispositivo y navegador, cookies</li>
  <li>Edad: para verificación de edad según legislación de menores (incluyendo datos del socio Seon)</li>
  <li>Imágenes, incluidas las generadas mediante IA si utiliza servicios de generación visual</li>
</ul>

<h2>Finalidades del Tratamiento</h2>
<p>Sus datos personales se procesan con fines legítimos, incluyendo:</p>
<ul>
  <li>Proporcionar acceso a funcionalidades y servicios del sitio</li>
  <li>Gestión de la cuenta del usuario</li>
  <li>Cumplimiento de obligaciones contractuales (pagos, entregas, atención al cliente)</li>
  <li>Análisis, mejora del servicio y personalización del contenido</li>
  <li>Identificación legal y verificación de edad</li>
  <li>Seguridad de la información y prevención del fraude</li>
  <li>Cumplimiento de obligaciones legales, incluidas fiscales y comerciales</li>
</ul>

<h2>Bases Legales del Tratamiento</h2>
<p>El tratamiento puede basarse en:</p>
<ul>
  <li>Su consentimiento (art. 6(1)(a) RGPD)</li>
  <li>Necesidad contractual (art. 6(1)(b))</li>
  <li>Intereses legítimos (por ejemplo, prevención del fraude — art. 6(1)(f))</li>
  <li>Obligaciones legales (art. 6(1)(c))</li>
</ul>

<h2>Tratamiento de Datos de Menores</h2>
<p>DressDown cumple estrictamente con las normas de protección infantil de la UE. No procesamos datos de menores de 18 años. Utilizamos tecnologías automáticas (Face++, DeepFace, Seon) para verificar la edad y restringir el acceso de menores a funciones no adecuadas. Los modelos generativos (p. ej., StyleGAN) tienen filtros que impiden la creación de imágenes de menores.</p>

<h2>Cesión de Datos a Terceros</h2>
<p>Podemos compartir sus datos personales con:</p>
<ul>
  <li>Proveedores de pago</li>
  <li>Proveedores de alojamiento y servicios informáticos</li>
  <li>Socios para verificación de identidad y edad (Seon)</li>
  <li>Autoridades competentes — solo conforme a la ley</li>
  <li>Asesores legales en caso de disputa</li>
</ul>
<p>Todos los datos compartidos están protegidos por acuerdos de confidencialidad y cláusulas contractuales estándar de la UE conforme al RGPD.</p>

<h2>Plazos de Conservación</h2>
<p>Los datos se conservarán:</p>
<ul>
  <li>Mientras su cuenta esté activa y hasta 5 años después de su eliminación — por obligaciones legales</li>
  <li>Registros de actividad — hasta 1 año</li>
  <li>Documentos financieros — entre 6 y 10 años, según legislación</li>
</ul>
<p>Tras el vencimiento, los datos serán eliminados.</p>

<h2>Sus Derechos</h2>
<p>Usted tiene derecho a:</p>
<ul>
  <li>Acceder a sus datos</li>
  <li>Corregir datos inexactos o desactualizados</li>
  <li>Eliminar sus datos (derecho al olvido)</li>
  <li>Restringir u oponerse al tratamiento</li>
  <li>Retirar su consentimiento en cualquier momento</li>
  <li>Presentar una reclamación ante una autoridad de control</li>
</ul>
<p>Envíe sus solicitudes a: <a href="mailto:support@dressdown.me">support@dressdown.me</a></p>

<h2>Seguridad de los Datos</h2>
<p>Implementamos medidas organizativas y técnicas de seguridad:</p>
<ul>
  <li>Cifrado SSL</li>
  <li>Protección contra accesos no autorizados</li>
  <li>Almacenamiento en centros de datos certificados en la UE</li>
  <li>Auditorías y actualizaciones periódicas</li>
</ul>

<h2>Cambios en la Política</h2>
<p>Podemos actualizar esta Política. Le notificaremos los cambios importantes a través del sitio web o por correo electrónico. Le recomendamos revisarla regularmente.</p>

<h2>Contacto</h2>
<p>Si tiene preguntas sobre privacidad o el tratamiento de sus datos:<br>
Correo electrónico: <a href="mailto:support@dressdown.me">support@dressdown.me</a><br>
Dirección legal: Vikova 532/8, Zizkov (Praha 3), Praga, República Checa</p>
`;


export default ded
